import * as React from 'react';
import { Space as AntSpace } from 'antd';

type SpaceProps = {
  className?: string;
};

const Space = ({ className, ...props }: SpaceProps & React.ComponentProps<typeof AntSpace>) => {
  const classNames = ['space', className];
  return <AntSpace {...props} className={classNames.join(' ')} />;
};

Space.defaultProps = {
  className: undefined,
};

export default Space;
